export enum EnumDocumentType {
  None = 'none',
  Sales = 'sales',
  Hr = 'hr',
  Introduction = 'introduction',
  Document = 'document',
  Template = 'template',
  Presentation = 'presentation',
  Other = 'other',
  Contract = 'contract',
}
